import api from './baseApi';
import _ from 'lodash';

let errorCodeFormat = (response, cb, errCb) => {
  let errorCode = _.get(response, 'data.errorCode');
  let status = _.get(response, 'data.status');
  if (errorCode == '100' || errorCode == '000') {
    if (cb) {
      cb(_.get(response, 'data.data'));
    }
  } else if (status == '000') {
    if (cb) {
      cb(_.get(response, 'data'));
    }
  } else if (errorCode == '936') {
    if (errCb) {
      errCb();
    }
  } else if (status == 'E0001') {
    let message = '序號不存在';
    errCb(message);
  } else if (status == 'E0004') {
    let message = '序號已過期';
    errCb(message);
  } else if (status == 'E0033') {
    let message = '序號已經使用';
    errCb(message);
  } else if (status == 'E0006') {
    let message = '序號已作廢';
    errCb(message);
  } else {
    if (errCb) {
      errCb();
    } else {
      let message = _.get(response, 'data.Message');
      alert(message);
    }
  }
};

export default (method, url, cb, config = {}, errCb) => {
  api(method, url, cb, config, errCb, errorCodeFormat);
};
